import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import FormatHour from '@shared/containers/FormatHour';

export const NOTIFICATION_TYPES = {
  DISCOUNT: 'discount',
  OPEN_IN: 'openin',
  CLOSED: 'closed',
  CLOSED_REASON: 'closed_reason',
};

const Container = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
  padding: ${({ theme }) => theme.commons.headerNotification.padding};

  ${({ isLast }) => isLast && `border: none;`}

  ${({ notificationType, theme }) =>
    css`
      color: ${theme.commons.headerNotification.color[notificationType]};
    `}
`;

const Text = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold}

  margin-right: 10px;
`;

const Label = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular}
`;

const renderHour = hour => <FormatHour value={hour}></FormatHour>;

const HeaderNotification = ({ type, label, text, nextHour, isLast }) => (
  <Container notificationType={type} isLast={isLast}>
    <Text>
      {`${text} `}
      {nextHour ? renderHour(nextHour) : ''}
    </Text>
    <Label notificationType={type}>{label}</Label>
  </Container>
);

HeaderNotification.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  nextHour: PropTypes.string,
  isLast: PropTypes.bool.isRequired,
};

export default HeaderNotification;
